import { render, staticRenderFns } from "./message.vue?vue&type=template&id=010fd3ce&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/login.scss?vue&type=style&index=0&id=010fd3ce&lang=scss&scoped=true&"
import style1 from "../assets/css/message.scss?vue&type=style&index=1&id=010fd3ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010fd3ce",
  null
  
)

export default component.exports